/* eslint-disable vue/valid-v-for */
<template>
  <v-card>
    <v-toolbar card color="white">
      <user-filters
        :value="$store.state.users.filters"
        @input="$store.commit('users/setFilters', value)"
        @search="onSearch"
      />
      <v-text-field
        v-model="localFilters.match"
        :placeholder="$t('action.buttons.search')"
        flat
        solo
        prepend-icon="search"
        hide-details
      />

      <meta-button
        v-if="
          can('create', 'user') || hasPermission('CREATE_USER_ACCOUNT_DISABLED')
        "
        type="new"
        @click="setNew"
      />
      <v-menu offset-y origin="center center" :nudge-bottom="10">
        <v-btn slot="activator" icon large flat>
          <v-avatar size="30px">
            <v-icon medium> more_vert </v-icon>
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            v-if="hasPermission('CREATE_USER_ACCOUNT_DISABLED')"
            ripple="ripple"
            @click="$router.push({ name: 'bulk-create-users' })"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ $t('titles.users.bulkCreate') }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="hasPermission('CREATE_USER_ACCOUNT_DISABLED')"
            ripple="ripple"
            @click="dialogImport = true"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ $t('action.buttons.import') }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            ripple="ripple"
            :disabled="false"
            @click="dialogExport = true"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ $t('action.buttons.export') }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            ripple="ripple"
            :disabled="!sendRegisterInvitationEnabled"
            @click="sendRegisterInvitation(filters)"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ $t('action.buttons.sendInvitationToFbase') }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        item-key="_id"
        :headers="headers"
        :loading="loading"
        :items="formatedList"
        :rows-per-page-items="[10, 25, 50]"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  color="success"
                  class="mr-1"
                  @click="sendNotification(props.item._id)"
                  v-on="on"
                >
                  mail
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.sendNotification') }}</span>
            </v-tooltip>
            <v-tooltip v-if="can('edit', 'user')" top>
              <template #activator="{ on }">
                <v-icon
                  color="success"
                  class="mr-1"
                  @click="setOne(props.item._id)"
                  v-on="on"
                >
                  edit
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.edit') }}</span>
            </v-tooltip>

            <v-tooltip v-if="!props.item.deleted && isAdmin" top>
              <template #activator="{ on }">
                <v-icon
                  color="error"
                  @click="ifDelete(props.item._id)"
                  v-on="on"
                >
                  delete
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.delete') }}</span>
            </v-tooltip>
          </td>
          <!-- <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td> -->
          <td class="text-xs-center">
            <button-state :state="props.item.validated" />
          </td>
          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.photo" alt />
            </v-avatar>
          </td>
          <td>{{ props.item.name }} {{ props.item.lastname1 }}</td>
          <td class="text-xs-center">
            <v-chip
              v-for="(object, index) in setRoleName(props.item.roles)"
              :key="index"
              small
              dark
              color="primary"
            >
              {{ object }}
            </v-chip>
          </td>
          <td v-if="props.item.teams.length > 0">
            <v-chip
              v-for="(team, index) of props.item.teams"
              :key="index + team.name"
              small
              color="transparent"
            >
              <v-avatar size="32">
                <img :src="team.logo" alt />
              </v-avatar>
              {{ team.name }}
            </v-chip>
          </td>
          <td
            v-else-if="
              props.item.teams.length === 0 && props.item.recordTeams.length > 0
            "
          >
            <v-chip small color="transparent">
              <v-avatar size="32">
                <img :src="props.item.recordTeams[0].logo" alt />
              </v-avatar>
              {{ props.item.recordTeams[0].name }}
            </v-chip>
          </td>
          <td>{{ serializeSubs(props.item.subscriptions) }}</td>
          <td>{{ props.item.provinceId }}</td>
          <td>{{ props.item.email }}</td>
          <!-- <td @click="openRoles(props)" class="text-xs-center cursor">
            <i class="icon material-icons">visibility</i>
          </td> -->
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openLastAccess(props.item._id)"
              >visibility</i
            >
          </td>
          <td class="text-xs-center">
            <v-tooltip v-if="props.item.isAccountDisabled" top>
              <template #activator="{ on }">
                <v-icon
                  color="success"
                  class="mr-1"
                  @click="sendRegisterInvitation({ _id: props.item._id })"
                  v-on="on"
                >
                  mail
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.sendInvitationToFbase') }}</span>
            </v-tooltip>
            <button-state v-else :state="true" />
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.deleted" />
          </td>
        </template>
        <template slot="expand">
          <v-container class="text-xs-left" mx-0>
            <v-layout row wrap>
              <v-flex
                v-for="(role, index) in filterRoles(selected.roles)"
                :key="index"
              >
                <v-icon v-if="role.confirm" color="success" small>
                  check_circle
                </v-icon>
                <v-icon v-else color="error" small> cancel </v-icon>
                <span>
                  {{ role.roleId.name }}
                  :
                </span>
                <v-chip
                  v-for="(object, index) in role.objects"
                  :key="index + object._id"
                  small
                  dark
                  color="primary"
                >
                  {{ object.name }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
    <dialog-last-access v-model="dialogLastAccess" :last-access="lastAccess" />
    <dialog-import-users v-if="dialogImport" @close="dialogImport = false" />
    <dialog-export-users v-if="dialogExport" @close="dialogExport = false" />
    <dialog-notification-form
      v-if="dialogNotification"
      :user-id="userId"
      :dialog="true"
      @close="dialogNotification = false"
    />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import UserFilters from './UserFilters'
import DialogNotificationForm from '@/components/apps/notifications/FormManager'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogExportUsers from '@/components/widgets/dialog/DialogExportUsers.vue'
import DialogImportUsers from '@/components/widgets/dialog/DialogImportUsers.vue'
import DialogLastAccess from '@/components/widgets/dialog/DialogLastAccess'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'UserList',
  components: {
    DialogDelete,
    DialogUpdatedRecord,
    DialogLastAccess,
    DialogImportUsers,
    DialogExportUsers,
    UserFilters,
    DialogNotificationForm,
  },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
      dialogLastAccess: false,
      dialogImport: false,
      dialogExport: false,
      dialogNotification: false,
      userId: '',
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.$emit('clear')
    },
    'filters.match': {
      handler: function () {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('users')
      },
    },
    'localPagination.page': {
      handler: function () {
        this.debounceFetch('users')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function () {
        this.debounceFetch('users')
      },
    },
    'localPagination.sortBy': {
      handler: function () {
        this.debounceFetch('users')
      },
    },
    'localPagination.descending': {
      handler: function () {
        this.debounceFetch('users')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.users.loading,
      selected: (state) => state.users.selected,
      filters: (state) => state.users.filters,
      pagination: (state) => state.users.pagination,
    }),
    ...mapGetters({
      formatedList: 'users/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        /* {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active'
        }, */
        {
          text: this.$t('fields.users.validated'),
          align: 'center',
          value: 'validated',
        },

        {
          text: this.$t('fields.users.image'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$tc('models.role', 2),
          value: 'roles',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$tc('models.team'),
          value: 'team',
        },
        {
          text: this.$tc('models.typeSubscription'),
          value: 'subscriptions',
          align: 'center',
        },
        {
          text: this.$tc('models.province'),
          value: 'province',
        },
        {
          text: this.$t('fields.users.email'),
          value: 'email',
        },
        /* {
          text: 'Roles',
          align: 'center',
          sortable: false
        }, */
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.users.lastAccess'),
          align: 'center',
          value: 'lastAccess',
        },
        {
          text: this.$t('fields.users.registeredUser'),
          align: 'center',
          value: 'isAccountDisabled',
        },
        {
          text: this.$t('fields.users.deleted'),
          align: 'center',
          value: 'deleted',
        },
      ]
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('users/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('users/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
    lastAccess() {
      if (!Array.isArray(this.selected.lastAccess)) return []

      return this.selected.lastAccess
    },
    sendRegisterInvitationEnabled() {
      return (
        this.filters.team ||
        this.filters.entity ||
        (this.filters.typeRole && this.filters.typeRole.length)
      )
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'users/fetchOne',
      fetchUserRoles: 'users/fetchUserRoles',
      fetchUserFollowings: 'users/fetchUserFollowings',
      fetchUserSubscriptions: 'users/fetchUserSubscriptions',
      setDelete: 'users/delete',
      reset: 'users/reset',
      fetchList: 'users/fetchList',
      sendRegisterInvitation: 'users/sendRegisterInvitation',
    }),
    setRoleName(props) {
      return props.map((role) => this.$t(`titles.roles.${role}`))
    },
    onSearch() {
      this.debounceFetch('users')

      this.localPagination.page = 1
    },
    setOne(id) {
      this.reset()
      this.fetchOne(id).then(() => {
        this.$emit('form')
        this.fetchUserRoles(id)
        this.fetchUserFollowings(id)
        this.fetchUserSubscriptions(id)
      })
    },
    setNew() {
      this.reset()
      this.$emit('form')
    },
    openRoles(props) {
      this.reset()
      if (!props.expanded) {
        this.fetchOne(props.item._id).then(() => {
          this.$nextTick(() => {
            props.expanded = true
          })
        })
      } else props.expanded = false
    },
    openUpdated(id) {
      this.reset()
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    openLastAccess(id) {
      this.reset()
      this.fetchOne(id).then(() => (this.dialogLastAccess = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    filterRoles(roles = []) {
      return roles.filter((role) => role.roleId && role.roleId.type !== 'fan')
    },
    sendNotification(item) {
      this.userId = item
      this.dialogNotification = true
    },
    serializeSubs(sub) {
      if (sub && sub.length > 0) {
        return sub.find((_sub) => !_sub.expired && !_sub.cancelled)
          ? sub.find((_sub) => !_sub.expired && !_sub.cancelled)
              .typeSubscription
          : '--'
      } else {
        return '--'
      }
    },
  },
}
</script>
